import { html, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { LeafElement } from '@cigna/dcws_leaf-web-components/components/leaf-element.js';
import { LeafAlert } from '@cigna/dcws_leaf-web-components/components/alert/alert.component.js';
import { ScopedRegistryHost } from '@lit-labs/scoped-registry-mixin';
import { I18nMixin } from '../../utils/i18n-mixin.js';
import styles from './pdl-viewer-alert.scss?inline';

export class CHCPDLViewerAlert extends ScopedRegistryHost(I18nMixin(LeafElement)) {
  static override styles = unsafeCSS(styles);
  static elementDefinitions = {
    'leaf-alert': LeafAlert,
  };
  protected override ns = 'pdl-viewer-alert';
  private searchParams?: URLSearchParams;

  @property({ reflect: true })
  variant: 'IFP' | 'nonIFP' = 'IFP';

  get link() {
    const yearType = this.yearType === 'CD' ? 'NY' : 'CD';
    this.searchParams?.set('pdlYearType', yearType);
    return `${location.pathname}?${this.searchParams?.toString()}`;
  }

  get yearType() {
    let yearType = this.searchParams?.get('pdlYearType') ?? 'CD';
    if (!['CD', 'NY'].includes(yearType)) {
      yearType = 'CD';
    }
    return yearType.toUpperCase();
  }

  get indicator() {
    let indicator = this.searchParams?.get('indicator') ?? this.variant;
    if (!['IFP', 'nonIFP'].includes(indicator)) {
      indicator = this.variant;
    }
    return indicator.toUpperCase();
  }

  override connectedCallback() {
    super.connectedCallback();
    this.searchParams = new URLSearchParams(location.search);
  }

  override render() {
    const loadingOrError = this.renderLoadingOrError();
    if (loadingOrError) {
      return loadingOrError;
    }

    const i18nKeyPrefix = `${this.ns}:${this.indicator}.${this.yearType}`;

    return html`
      <leaf-alert variant="standalone" type="info" subtle open>
        ${unsafeHTML(this.i18n?.t(`${i18nKeyPrefix}.heading`))}
        ${unsafeHTML(this.i18n?.t(`${i18nKeyPrefix}.body`, { link: this.link }))}
      </leaf-alert>
    `;
  }
}
